export const artifactViewSubtabs = {
  summary: 'Summary',
  technical: 'Technical Info',
  risk: 'Risk Score',
  fix: 'Library Fix Info',
  exploit: 'Exploit Info',
  references: 'References',
  signatures: 'Library Signatures',
  vulnMethods: 'Vulnerable Methods',
  legal: 'Legal',
  library: 'Library Information',
};

export const cvss2Values = {
  base: {
    AV: {
      name: 'Access Vector',
      values: {
        L: 'Local',
        A: 'Adjacent',
        N: 'Network',
      },
    },
    AC: {
      name: 'Access Complexity',
      values: {
        H: 'High',
        M: 'Medium',
        L: 'Low',
      },
    },
    Au: {
      name: 'Authentication',
      values: {
        M: 'Multiple',
        S: 'Single',
        N: 'None',
      },
    },
    C: {
      name: 'Confidentiality Impact',
      values: {
        N: 'None',
        P: 'Partial',
        C: 'Complete',
      },
    },
    I: {
      name: 'Integrity Impact',
      values: {
        N: 'None',
        P: 'Partial',
        C: 'Complete',
      },
    },
    A: {
      name: 'Availability Impact',
      values: {
        N: 'None',
        P: 'Partial',
        C: 'Complete',
      },
    },
  },
  temporal: {
    E: {
      name: 'Exploitability',
      values: {
        ND: 'Not Defined',
        U: 'Unproven',
        POC: 'Proof of concept',
        F: 'Functional exploit',
        H: 'High',
      },
    },
    RL: {
      name: 'Remediation Level',
      values: {
        ND: 'Not Defined',
        OF: 'Official fix',
        TF: 'Temporary fix',
        W: 'Workaround',
        U: 'Unavailable',
      },
    },
    RC: {
      name: 'Report Confidence',
      values: {
        ND: 'Not Defined',
        UC: 'Unconfirmed',
        UR: 'Uncorroborated',
        C: 'Confirmed',
      },
    },
  },
};

export const artifactViewFilterNameMap = {
  CROSS_REFERENCE: 'Cross Reference',
  FOUND_BY: 'Found By',
  KNOWN_EXPLOIT: 'Known Exploit',
  RELATED_ARTIFACT: 'Related artifact',
  METASPLOIT: 'Metasploit',
  BLOG_POST: 'Blog Post',
  BUGZILLA_ENTRY: 'Bugzilla Entry',
  COMMUNITY_MEMBER_WRITE_UP: 'Community Member Write Up',
  CVE_REQUEST: 'CVE Request',
  DEBIAN_BUG_TRACKER_TICKET: 'Debian Bug Tracker Ticket',
  GITHUB_FIX_COMMIT: 'GitHub Fix Commit',
  GITHUB_FIX_PR: 'GitHub Fix Pull Request',
  GITHUB_FIX_TAG: 'GiHub Fix Tag',
  GITHUB_ISSUE: 'GitHub Issue',
  MAILING_LIST_DISCLOSURE: 'Mailing List Disclosure',
  NODE_SECURITY: 'Node Security',
  OTHER: 'Other',
  RESEARCH_PAPER: 'Research Paper',
  RUBY_ADVISORY: 'Ruby Advisory',
  RUBY_SECURITY_ANNOUNCEMENT: 'Ruby Security Announcement',
  VENDOR_DISCLOSURE: 'Vendor Disclosure',
  VENDOR_GIT_FIX_COMMIT: 'Vendor Git Fix Commit',
  VENDOR_ISSUE_TRACKER_TICKET: 'Vendor Issue Tracker Ticket',
  VENDOR_JIRA: 'Vendor Jira Ticket',
  VENDOR_LAUNCHPAD_TICKET: 'Vendor Launchpad Ticket',
  VENDOR_MERCURIAL_CHANGESET: 'Vendor Mercurial Changeset',
  VENDOR_RELEASE_NOTES: 'Vendor Release Notes',
  VENDOR_SVN_FIX_REVISION: 'Vendor SVN Fix Revision',
  VULNERABLE_LINE: 'Vulnerable Line',
  X_FORCE_ISS_ENTRY: 'X-Force ISS Entry',
  ALL: 'ALL',
};

export const languageToSourceMap = {
  java: ['Maven_or_Gradle', 'Maven'],
  ruby: ['RubyGems', 'Gem'],
  javascript: ['npm', 'Bower'],
  python: ['PyPI'],
  objectivec: ['CocoaPods'],
  swift: ['CocoaPods'],
  php: ['Packagist'],
  go: ['GO'],
  cpp: ['SO'],
  csharp: ['NuGet'],
  os: ['RPM'],
};

export const languageToUrl = {
  objectivec: 'objective-c',
  js: 'javascript',
};

export const packageManagerTypeMap = {
  bower: 'Bower',
  gem: 'RubyGems',
  maven: 'Maven',
  npm: 'npm',
  pypi: 'PyPI',
  cocoapods: 'CocoaPods',
  packagist: 'Packagist',
  nuget: 'NuGet',
  rpm: 'RPM',
};

export const searchSingleValueFacets = [
  'severity',
  'cvss2_severity',
  'cvss3_severity',
  'disclosed',
  'released',
];
/*
  Enable this to allow user to see
    - stats about cocoapods /explore
    - able to seelct the checkbox to search cocoapods
*/
export const ALLOW_COCOAPODS_SEARCH = true;
export const ALLOW_COCOAPODS_EXPLORE = false;

/*
  Enable this to allow user to see
    - stats about go inside explore view
    - search1 and search2 to include go.
*/
export const ALLOW_GO_SEARCH_EXPLORE = true;

/*
  Enable this to allow user to see
    - stats about go inside explore view
    - search1 and search2 to include php.
*/
export const ALLOW_PHP_SEARCH = true;
export const ALLOW_PHP_EXPLORE = false;

// Enable this to allow the "all" tab inside explore page
export const SHOW_ALL_TAB_IN_STATS_PAGE = false;
/*
  By default this value should be "all". However if all is hidden from SHOW_ALL_TAB_IN_STATS_PAGE val,
  we can put another vale here.

  See LanguageStatsMenu.js for the available language value.
*/
export const DEFAULT_LANGUAGE_IN_STATS_PAGE = 'js';

/*
  Enable this to allow user to see
    - CSHARP search filter options
*/
export const ALLOW_CSHARP_SEARCH = true;

/*
  Enable this to allow user to see
    - OS search filter options
*/
export const ALLOW_OS_SEARCH = true;

/*
  Enable this to allow user to see
    - CPP search filter options
*/
export const ALLOW_CPP_SEARCH = true;

export const GLOSSARY = {
  ENHANCED: 'Enhanced artifacts are vulnerability artifacts with available teardown information.',
};

export const vulnMethodsSupportedLanguages = ['PYTHON', 'JAVA', 'RUBY', 'JS', 'CSHARP', 'GO'];

export const vulnMethodsSupportedCoordTypes = ['PYPI', 'MAVEN', 'GEM', 'NPM', 'NuGet', 'GO'];

export const commitHashSupportedLanguages = ['GO'];

export const commitHashSupportedPackageManagers = ['GO'];

export const vulnerabilityRangeTypesMap = {
  VERSIONS: 'versions',
  COMMIT_HASHES: 'commitHashes',
};

export const releaseStatusMap = {
  RELEASE: 'release',
};

export const dateRangeOptions = [
  { value: 'last7days', label: 'Last 7 days' },
  { value: 'last14days', label: 'Last 14 days' },
  { value: 'last30days', label: 'Last 30 days' },
  { value: 'last3months', label: 'Last 3 months' },
  { value: 'custom', label: 'Custom Range' },
];

export const RANGE_SPLITTER = '..';

export const vulnSectionsMap = {
  VULNERABILITY_TECHNICAL_INFORMATION: 'Technical Information',
  EXPLOIT_INFORMATION: 'Exploit Information',
  LIBRARY_FIX_INFORMATION: 'Library Fix Instructions',
  VULNERABLE_METHODS: 'Vulnerable Methods',
  LIBRARY_INFORMATION: 'Library Information',
  LIBRARY_VULNERABILITY_HISTORY: 'Library Vulnerability History',
  LIBRARY_RELEASE_HISTORY: 'Library Release History',
  LIBRARY_VERSION_VULNERABILITIES: 'Library Version Vulnerabilities',
  RISK_SCORE: 'Risk Score',
  REFERENCES: 'References',
  LIBRARY_SIGNATURES: 'Library Signatures',
};

export const paywallComponentText = {
  'Vulnerability Technical Information':
    'Understand the security risks that a vulnerability poses by reviewing its technical details and probable fixes',
  'Exploit Information':
    'Test that your application is actually vulnerable with exploit information, which exploits the issue for validation purposes.',
  'Library Fix Instructions':
    'Knowing that there is a potential problem is important, but knowing how to fix it is crucial. Get fix instructions and recommended actions, for direct and indirect libraries.',
  'Vulnerable Methods':
    'Your code is only vulnerable if you are calling the vulnerable methods of a vulnerable library. Save time with our call graph that checks if there is a call chain to the vulnerable method.',

  'Library Vulnerability History':
    'See all the vulnerabilities that have affected a library over time, and whether a particular library version is affected.',
  'Library Release History':
    "View all of a library's versions and easily see their vulnerabilities.",
  'Library Version Vulnerabilities':
    'Browse and find affected library versions and view all their vulnerabilities.',

  'Risk Score': 'See which aspects of a vulnerability are most dangerous.',
  References:
    "Further your understanding of a vulnerability with these key references. We've done the research for you!",
  'Library Signatures':
    'Get the available coordinates, bytecode hashes, and file hashes of each version of an affected library.',
};

export const ENVIRONMENT_MAP = {
  QA: 'QA',
  DEV: 'DEV',
  PROD: 'PROD',
  ONPREM: 'ONPREM',
};

export const SOURCECLEAR_COMPONENTS = {
  VULNERABILITY_DATABASE: {
    name: 'Vulnerability Database',
    slug: 'vulnerability-database',
  },
};

export const API_COMPATIBLE_QUERY_VALUES_MAP = {
  source: {
    native: 'so',
  },
};

export const xsrfCookieName = 'XSRF-TOKEN';
export const veracodeLogout = '/#!/login?logout';
